module.exports = __webpack_public_path__ + "static/img/2_1_1_2.2c518848.jpg";